import { Component, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';
import { AppConfigService } from '@app/common/app-config.service';
import { DataTransformationService } from '@app/common/data-transformation.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss']
})
export class SearchResultComponent {
  @Input() searchFormValue;
  @Input() patientList: any;
  @Input() sourcePatientId;
  @Output() selectPatient = new EventEmitter();
  dateTimePref = {} as any;
  private uvDateTimeSubscriber: Subscription;
  patientAge: any;

  constructor(
    private appConfigService: AppConfigService,
    private cd: ChangeDetectorRef,
    private dataTransformationService: DataTransformationService
  ) {}

  selectDestinationPatient(selectedPatientInfo) {
    this.selectPatient.emit(selectedPatientInfo);
  }

  ngOnInit(): void {
    this.dateTimePref = this.appConfigService.getDateTimePref();
    this.uvDateTimeSubscriber = this.appConfigService.getDateTimeObserver().subscribe(value => {
      this.dateTimePref = value;
      this.cd.detectChanges();
    });
  }

  getPatientAge(patient: any) {
    return this.dataTransformationService.calculateStudyAge(patient.birthDate, Date.now());
  }

  ngOnDestroy(): void {
    this.uvDateTimeSubscriber.unsubscribe();
  }
}
